var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewEnergy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19263 8.79468L9.8676 7.46052C10.9499 6.59851 11.491 6.1671 11.8318 6.3799C12.1727 6.5927 11.9956 7.25271 11.6423 8.57107L11.6091 8.69576C11.4811 9.17123 11.4179 9.40897 11.5293 9.59849L11.5351 9.60847C11.6515 9.79633 11.8992 9.86283 12.3938 9.995C13.2849 10.2336 13.7304 10.3524 13.8086 10.6633C13.8097 10.6686 13.8109 10.6738 13.8119 10.6791C13.8809 10.9917 13.5293 11.271 12.8268 11.8312L11.1519 13.1646C10.0688 14.0274 9.52762 14.458 9.18681 14.2452C8.84682 14.0324 9.02388 13.3724 9.37716 12.054L9.41041 11.9293C9.53759 11.4547 9.6016 11.2169 9.48938 11.0266L9.48356 11.0166C9.36719 10.8296 9.11947 10.7631 8.62488 10.6301C7.73378 10.3915 7.28823 10.2726 7.21009 9.96175C7.20891 9.9565 7.2078 9.95124 7.20677 9.94596C7.13777 9.63424 7.48939 9.35411 8.19263 8.79468Z",
    stroke: "#213958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35352 3.11222C7.61662 2.38147 9.05051 1.99776 10.5098 2.00001C15.1008 2.00001 18.8223 5.72152 18.8223 10.3125C18.8223 14.9035 15.1008 18.625 10.5098 18.625C5.91877 18.625 2.19727 14.9035 2.19727 10.3125C2.19727 8.7988 2.60208 7.3782 3.30948 6.15626",
    stroke: "#213958",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00771 5.47294L3.38784 5.22552C3.81777 5.18083 4.20228 5.49374 4.24588 5.92379L4.51093 8.53831",
    stroke: "#213958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewEnergy);
export default __webpack_public_path__ + "static/media/renew-energy.cfa10e083932b081a8eecf7a980e186a.svg";
export { ForwardRef as ReactComponent };